import { render } from "./InactivityTimeout.vue?vue&type=template&id=dca2d370"
import script from "./InactivityTimeout.vue?vue&type=script&lang=js"
export * from "./InactivityTimeout.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.3.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__